import { Route } from 'src/routes/Route'

export const AccountRoute = Route({ path: '/account' })
export type AccountRoute = Route<typeof AccountRoute>
